
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getBookingSegments } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

const FormSegments = () => {

    const { t } = useTranslation('booking');

    const segmentsQuery = useQuery({
        queryKey: [ReactQueryKey.BookingSegments, {}],
        queryFn: () => getBookingSegments(),
        enabled: false
    });

    const handleOnOpen = () => {
        if(segmentsQuery.data == undefined) 
            segmentsQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="segments"
            label={t('label.segments')}
            options={segmentsQuery.data ?? []}
            loading={segmentsQuery.isLoading}
            multiple
            isOptionEqualToValue={(option, value) => option.code === value.code}
            onOpen={handleOnOpen}
        />
    );
};

export default FormSegments;